export default "__VITE_ASSET__06LyI4cR__"